import urlPrefix from "./apiPrefix";

export const getRisksSettings = () => `${urlPrefix.value}/tax-web-control/api/risks/settings`;
export const postRisksSettings = () => `${urlPrefix.value}/tax-web-control/api/risks/settings`;
export const getRisksCalendar = () => `${urlPrefix.value}/tax-web-control/api/risks/calendar`;
export const postRisksCalendar = () => `${urlPrefix.value}/tax-web-control/api/risks/calendar`;
export const getRisksStat = () => `${urlPrefix.value}/tax-web-control/api/risks/stat`;
export const getRisksStatByTin = (tin: string) => `${urlPrefix.value}/tax-web-control/api/risks/stat/${tin}`;
